export default function SubmitCta() {
  return (
    <section id="submit" className="border-b border-background-200 bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-8 rounded-lg border border-background-200 bg-background-50 p-6 md:p-10 lg:grid-cols-2">
          <div>
            <p className="flex items-center gap-2 text-xs tracking-[0.3em] text-primary-600">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-upload-2-line" />
              </span>
              SUBMIT · 投稿入口
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              你手上的截图，
              <br className="hidden md:block" />
              可能就是今天缺的那一块
            </h2>
            <p className="mt-3 max-w-lg text-sm text-foreground-600 md:text-base">
              投稿通道每日开放，栏目组会在整理前统一核对来源与时间戳。线索越完整，进入六点档的专题就越快。
            </p>

            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="#today"
                className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-add-line" />
                </span>
                前往今日专题
              </a>
              <a
                href="#columns"
                className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-folder-open-line" />
                </span>
                浏览栏目目录
              </a>
            </div>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-100 p-5">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-base font-bold text-foreground-950">投稿会经过这几步</h3>
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-700">每日审核</span>
            </div>
            <ul className="mt-4 space-y-3">
              {[
                { icon: 'ri-checkbox-circle-line', text: '核对来源与原始时间戳' },
                { icon: 'ri-links-line', text: '与公开说法交叉比对' },
                { icon: 'ri-layout-masonry-line', text: '并入对应专题的脉络里' },
              ].map((item) => (
                <li key={item.text} className="flex items-center gap-3 rounded-md bg-background-50 px-4 py-3">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                    <i className={item.icon} />
                  </span>
                  <span className="text-sm text-foreground-700">{item.text}</span>
                </li>
              ))}
            </ul>
            <p className="mt-4 text-xs text-foreground-500">
              本页为静态展示，投稿入口按钮暂不接入真实提交。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}